import React from "react";
import Formulario from "./Formulario"
import { useMediaQuery } from "react-responsive";

const FormStart = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  return (
    <>
      {isMobile && (
        <div className="mt-5">
          <Formulario/>
        </div>
        
      )}
    </>
  );
};

export default FormStart;
